import { Space } from "antd-mobile";
import { Icon } from "../Icon";
import styles from "./index.module.scss";
type AmountWithIconProps = {
  className?: string;
  size?: string;
  amount?: number | string;
};
export const AmountWithIcon = (props: AmountWithIconProps) => {
  return <Space className={`${styles.amount} ${props.className || ""}`} data-sentry-element="Space" data-sentry-component="AmountWithIcon" data-sentry-source-file="index.tsx">
      <span>{props.amount}</span>
      <Icon name={"vcoin"} size={props.size || "20px"} className={`${styles.icon}`} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
    </Space>;
};